// extracted by mini-css-extract-plugin
export default {"legend":"Sna-z","legendSpacing":"Tna-z"};